module.exports = __webpack_public_path__ + "img/mood4.d5fedef4.png";